module.exports = __webpack_public_path__ + "media/images/main_arena-3f5a1505d70d06aa966cd4b28af4fa8d.png";